import { render } from "./HeaderViewOld.vue?vue&type=template&id=50e9254d&scoped=true"
import script from "./HeaderViewOld.vue?vue&type=script&lang=js"
export * from "./HeaderViewOld.vue?vue&type=script&lang=js"

import "./HeaderViewOld.vue?vue&type=style&index=0&id=50e9254d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e9254d"]])

export default __exports__